import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';

import ReadAlarmResponse from '../models/read-alarm-response';
import ReadEmergencyAlarmResponse from '../models/read-emergency-alarm-response';
import ReadHistoryCommand from '../models/read-history-command';
import ReadHistoryResponse from '../models/read-history-response';

const historyBaseUrl = '/api/v1/history';

enum HistoryQueryPaths {
  ReadHistory = 'ReadHistory',
  ReadAlarm = 'ReadAlarm',
  ReadEmergencyAlarm = 'ReadEmergencyAlarm',
}

const readHistory = async (axiosInstance: AxiosInstance, body: ReadHistoryCommand): Promise<ReadHistoryResponse> => {
  const response = await axiosInstance.post(`${historyBaseUrl}/${HistoryQueryPaths.ReadHistory}`, body);
  return response.data;
};

const readAlarm = async (axiosInstance: AxiosInstance, alarmId: string): Promise<ReadAlarmResponse> => {
  const response = await axiosInstance.get(`${historyBaseUrl}/${HistoryQueryPaths.ReadAlarm}/${alarmId}`);
  return response.data;
};

const readEmergencyAlarm = async (axiosInstance: AxiosInstance, emergencyAlarmId: string): Promise<ReadEmergencyAlarmResponse> => {
  const response = await axiosInstance.get(`${historyBaseUrl}/${HistoryQueryPaths.ReadEmergencyAlarm}/${emergencyAlarmId}`);
  return response.data;
};

export const useLazyGetHistory = (body: ReadHistoryCommand) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [HistoryQueryPaths.ReadHistory],
    queryFn: () => readHistory(authenticatedInstance, body),
    enabled: false,
  });
};

export const useLazyGetAlarm = (alarmId: string) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [HistoryQueryPaths.ReadAlarm, alarmId],
    queryFn: () => readAlarm(authenticatedInstance, alarmId),
    enabled: false,
  });
};

export const useLazyGetEmergencyAlarm = (emergencyAlarmId: string) => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [HistoryQueryPaths.ReadEmergencyAlarm, emergencyAlarmId],
    queryFn: () => readEmergencyAlarm(authenticatedInstance, emergencyAlarmId),
    enabled: false,
  });
};
